/**
 * Starting points offered when creating an eval config — the eval-config
 * counterpart of `GENERIC_BASE_TEMPLATES`. The ids travel in
 * `CreateEvalConfigPayload.copy_from`; the content behind `PBQA_STARTER`
 * lives on the backend only (`backend/data/eval_config_starter.json`,
 * regenerated from a pre-prod export by
 * `scripts/pbqa-eval/export-starter.mjs`), so the FE bundle carries the
 * names, not the prompts.
 */
export const EVAL_CONFIG_STARTERS = [
  { id: 'BLANK', name: 'Blank — add packs yourself' },
  { id: 'PBQA_STARTER', name: 'Contract Guidance starter — the current champion prompts' },
] as const;

export type EvalConfigStarterId = (typeof EVAL_CONFIG_STARTERS)[number]['id'];
